import { useState } from 'react';
import { useApi, apiCalls } from '../api.ts';

export function SupportBubble() {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const reset = () => {
    setEmail('');
    setSubject('');
    setMessage('');
    setError(null);
    setSuccess(false);
  };

  const close = () => {
    setOpen(false);
    reset();
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    setSending(true);
    try {
      await apiCalls.quickTicket(api, { email, subject, message });
      setSuccess(true);
      setTimeout(close, 1500);
    } catch (err) {
      const e = err as { response?: { data?: { error?: string } }; message?: string };
      setError(e.response?.data?.error ?? e.message ?? 'unknown_error');
    } finally {
      setSending(false);
    }
  };

  if (!open) {
    return (
      <button
        className="support-bubble"
        title="Support"
        onClick={() => setOpen(true)}
        aria-label="Open support"
      >
        <i className="fa-solid fa-life-ring text-2xl" />
      </button>
    );
  }

  return (
    <div className="support-modal-backdrop" onClick={close}>
      <div className="support-modal" onClick={(e) => e.stopPropagation()}>
        <header>
          <div className="font-semibold">Quick ticket</div>
          <button
            className="text-white"
            onClick={close}
            aria-label="Close"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </header>
        <form className="content" onSubmit={submit}>
          <div className="row">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="row">
            <label htmlFor="subject">Sujet</label>
            <input
              id="subject"
              value={subject}
              required
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>
          <div className="row">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              value={message}
              required
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
          {error ? <div className="support-error">Erreur : {error}</div> : null}
          {success ? <div className="support-success">Ticket envoyé !</div> : null}
          <div className="actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={close}
              disabled={sending}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={sending || !email || !subject || !message}
            >
              {sending ? 'Envoi…' : 'Envoyer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
